import { render, staticRenderFns } from "./rwjabatan.vue?vue&type=template&id=fcf2e6b6"
import script from "./rwjabatan.vue?vue&type=script&lang=js"
export * from "./rwjabatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports